














































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import AddressForm from "@/components/AddressForm.vue";
import { Order } from "../../models/order";
import AddressHelpers, {
  AddressTypeConsultantToDeliver,
  AddressTypePickup,
  AddressTypeStreet,
  Address,
} from "../../models/address";
import billing from "../../services/billing";
import { Package } from "../../models/package";

@Component({
  components: {
    loader,
    AddressForm,
  },
})
export default class ShippingAddress extends Vue {
  public loadingQuotes = false;
  get selectedTab() {
    if (!this.order) {
      return AddressTypeStreet;
    }
    return this.order.delivery_address
      ? this.order.delivery_address.type
      : AddressTypeStreet;
  }

  private get complete() {
    if (this.selectedTab === AddressTypeStreet) {
      return this.valid;
    }
    return true;
  }
  @Mutation("setLastErr") public setLastErr: any;

  // order passed as prop, then emit('update',{field: value}, sync?) to update.
  @Prop({ required: true }) public order?: Order;

  public shippingQuotes: Package[] = [];
  private loading = false;

  private mode = "select-type";

  private valid = false;
  private shippingOptions = [
    {
      text: "Sales Consultant to deliver to customer",
      value: AddressTypeConsultantToDeliver,
    },
    {
      text: "Customer to collect at hearX offices",
      value: AddressTypePickup,
    },
    {
      text: "Ship to customer address",
      value: AddressTypeStreet,
      showQuote: true,
    },
  ];

  public setTab(tab: string) {
    if (!this.order) {
      return;
    }
    const add = this.order.delivery_address
      ? AddressHelpers.Copy(this.order.delivery_address)
      : AddressHelpers.New();
    add.type = tab;
    this.setShippingAddress(add);
  }

  private async setShippingAddress(add: Address) {
    // if (this.order) {
    //   let pkgs = this.order.packages.filter(
    //     (p: Package) => p.category != "shipping"
    //   );
    //   this.$emit("update", { delivery_address: add, packages: pkgs });
    // } else {
    this.$emit("update", { delivery_address: add });
    // }
    if (
      this.order &&
      this.order.delivery_address &&
      this.order.delivery_address.type === AddressTypeStreet &&
      this.complete
    ) {
      this.shippingQuotes = [];
      // this.loadingQuotes = true;
      // try {
      //   this.shippingQuotes = await billing.getOrderShippingQuotes(this.order);
      // } catch (e) {
      //   this.setLastErr(e);
      // }
      // this.loadingQuotes = false;
    }
  }

  private async back() {
    if (this.mode === "quote") {
      this.mode = "select-type";
      return;
    }
    this.$router.push("packages");
  }

  private selectShippingPackage(code: any) {
    if (!this.order || !this.order.packages) {
      return;
    }
    const opt = this.shippingQuotes.find((p: Package) => p.code === code);
    if (!opt) {
      return;
    }

    const packages = this.order.packages.filter(
      (p: Package) => p.category !== "shipping" || p.bundle_id
    );
    try {
      packages.push(opt);
      this.$emit("update", { packages }, true, "billing_address");
    } catch (e) {
      this.setLastErr(e);
      return;
    }
  }

  private async next() {
    if (!this.order) {
      return;
    }

    if (this.mode === "select-type" && this.selectedTab === AddressTypeStreet) {
      this.loading = true;
      this.mode = "quote";
      this.shippingQuotes = [];
      try {
        this.shippingQuotes = await billing.getOrderShippingQuotes(this.order);
      } catch (e) {
        console.log(e.response);
        this.setLastErr(e);
        return;
      }

      this.loading = false;
      return;
    }

    if (!this.complete) {
      return;
    }

    this.$emit("update", {}, true, "billing_address");
  }

  // list of non bundle quotes
  get quotes() {
    return this.shippingQuotes.filter((p) => !p.bundle_id)
  }

  get bundleShippingPackages() {
    return this.shippingQuotes.filter((p) => p.bundle_id)
  }
}
